import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { Screen } from '@/components/Layout/Screen';
import { MinorReviewCompleteForm } from '@/components/PageForm/MinorReviewCompleteForm/MinorReviewCompleteForm';

import { ROUTE } from '@/constants/routes';

import { useAppSelector } from '@/hooks/redux';

import { selectLoggedInUser } from '@/redux/auth/selectors';
import { selectRightStartFeature } from '@/redux/configs/selectors';

export default function MinorReviewCompleteScreen() {
  const navigate = useNavigate();
  const user = useAppSelector(selectLoggedInUser);
  const enabledRightStartAccount = useAppSelector(selectRightStartFeature);

  useEffect(() => {
    if (user && !enabledRightStartAccount) {
      navigate(ROUTE.MORE_INFORMATION, { replace: true });
    }
  }, [navigate, user, enabledRightStartAccount]);

  if (user && !enabledRightStartAccount) {
    return null;
  }

  return (
    <Screen>
      <MinorReviewCompleteForm />
    </Screen>
  );
}
